import React from "react";
import Spinner from "./Spinner";
import styles from "./Fallback.module.css";
const Fallback = () => {
  return (
    <div className={`${styles.fallback} text-center d-block w-100 `}>
      <Spinner classes="spinner-border text-primary" />
    </div>
  );
};

export default Fallback;
